export const Footer = () => {
  return (
    <footer className="app-footer section py-5 px-6 tile is-justify-content-center">
      <p className="copyright is-align-self-flex-end">
        &copy; All rights reserved 2021
      </p>
    </footer>
  );
};
